import { Checkbox, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMapBrokerageCode extends Layout {
    checkboxSaveAsBlank: Checkbox;
    labelFromWarningIcon: Label;
    labelToWarningIcon: Label;
    panelFromErrorMessage: Panel;
    panelMapBrokerage: Panel;
    panelToErrorMessage: Panel;
    sourceMapBrokerageCode: DataSource;
    textboxCodeSource: Textbox;
    textboxCodeType: Textbox;
    textboxFromCode: Textbox;
    textboxFromCodeDesc: Textbox;
    textboxFromErrorMessage: Textbox;
    textboxToCode: Textbox;
    textboxToErrorMessage: Textbox;
}
